import { render } from "./Concept.vue?vue&type=template&id=6ea27c3a&bindings={\"title\":\"props\",\"label\":\"props\",\"paragraphs\":\"props\"}"
import script from "./Concept.vue?vue&type=script&lang=js"
export * from "./Concept.vue?vue&type=script&lang=js"

import "./Concept.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script